import { createSelector } from 'reselect';
import {
  AUTOMATIC_SELL_TRANSACTION,
  AUTOMATIC_SELL_TRANSACTION_EDIT,
  BUY_TRANSACTION,
  SELL_TRANSACTION,
  APP_BUY_TRANSACTION,
  APP_SELL_TRANSACTION,
  RECURRING_BUY_TRANSACTION_EDIT,
  RECURRING_BUY_TRANSACTION,
  IRA_AUTOMAX_TRANSACTION,
  RECURRING_EXCHANGE_TRANSACTION,
  RECURRING_EXCHANGE_TRANSACTION_EDIT,
  EXCHANGE_TRANSACTION,
  AUTOMATIC_LANDING,
  LANDING,
  ADD_BANK,
  QCD_ENTRY,
  QCD_TRANSACTION,
  ROTH_CONVERSION,
  transactionType,
} from '../../../utils/transactions-util';

export const getApplicationStatus = (state) => {
  // Check for the calls that are needed to load the application
  switch (transactionType()) {
    case BUY_TRANSACTION:
    case APP_BUY_TRANSACTION:
      return {
        isLoading:
          state?.personalInformation.isLoading ||
          state?.userFunds.isLoading ||
          state?.userFunds.agreementMapIsLoading ||
          state?.userProductTypes.isLoading ||
          state?.existingBanks.isLoading ||
          state?.RMDSetting.isLoading ||
          state?.IRALimit.isLoading,
        isLoaded:
          state?.personalInformation.isLoaded &&
          state?.userFunds.isLoaded &&
          state?.userFunds.agreementMapIsLoaded &&
          state?.userProductTypes.isLoaded &&
          state?.existingBanks.isLoaded &&
          state?.RMDSetting.isLoaded &&
          state?.IRALimit.isLoaded,
        hasFailed:
          state?.personalInformation.hasFailed ||
          state?.userFunds.hasFailed ||
          state?.userFunds.agreementMapHasFailed ||
          state?.userProductTypes.hasFailed ||
          state?.existingBanks.hasFailed ||
          state?.RMDSetting.hasFailed ||
          state?.IRALimit.hasFailed,
      };
    case SELL_TRANSACTION:
    case APP_SELL_TRANSACTION:
    case QCD_ENTRY:
      return {
        isLoading:
          state?.personalInformation.isLoading ||
          state?.userFunds.isLoading ||
          state?.userFunds.agreementMapIsLoading ||
          state?.userProductTypes.isLoading ||
          state?.existingBanks.isLoading ||
          state?.RMDSetting.isLoading,
        isLoaded:
          state?.personalInformation.isLoaded &&
          state?.userFunds.isLoaded &&
          state?.userFunds.agreementMapIsLoaded &&
          state?.userProductTypes.isLoaded &&
          state?.existingBanks.isLoaded &&
          state?.RMDSetting.isLoaded,
        hasFailed:
          state?.personalInformation.hasFailed ||
          state?.userFunds.hasFailed ||
          state?.userFunds.agreementMapHasFailed ||
          state?.userProductTypes.hasFailed ||
          state?.existingBanks.hasFailed ||
          state?.RMDSetting.hasFailed,
      };
    case RECURRING_BUY_TRANSACTION_EDIT:
    case RECURRING_BUY_TRANSACTION:
      return {
        isLoading:
          state?.personalInformation.isLoading ||
          state?.userFunds.isLoading ||
          state?.userProductTypes.isLoading ||
          state?.existingBanks.isLoading ||
          state?.RMDSetting.isLoading ||
          state?.IRALimit.isLoading ||
          state?.automaticInvestments.systematicPurchasesLoading ||
          state?.automaticInvestments.systematicRedemptionsLoading ||
          state?.automaticInvestments.systematicExchangesLoading ||
          state?.automaticInvestments.autoMaxLoading,
        isLoaded:
          state?.personalInformation.isLoaded &&
          state?.userFunds.isLoaded &&
          state?.userFunds.agreementMapIsLoaded &&
          state?.userProductTypes.isLoaded &&
          state?.existingBanks.isLoaded &&
          state?.RMDSetting.isLoaded &&
          state?.IRALimit.isLoaded &&
          !state?.automaticInvestments.systematicPurchasesLoading &&
          !state?.automaticInvestments.systematicRedemptionsLoading &&
          !state?.automaticInvestments.systematicExchangesLoading &&
          !state?.automaticInvestments.autoMaxLoading,
        hasFailed:
          state?.personalInformation.hasFailed ||
          state?.userFunds.hasFailed ||
          state?.userProductTypes.hasFailed ||
          state?.existingBanks.hasFailed ||
          state?.RMDSetting.hasFailed ||
          state?.IRALimit.hasFailed ||
          state?.automaticInvestments.systematicPurchasesFailed ||
          state?.automaticInvestments.systematicRedemptionsFailed ||
          state?.automaticInvestments.systematicExchangesFailed ||
          state?.automaticInvestments.autoMaxFailed,
      };
    case IRA_AUTOMAX_TRANSACTION:
    case AUTOMATIC_SELL_TRANSACTION:
    case AUTOMATIC_SELL_TRANSACTION_EDIT:
    case RECURRING_EXCHANGE_TRANSACTION:
    case RECURRING_EXCHANGE_TRANSACTION_EDIT:
    case AUTOMATIC_LANDING:
      return {
        isLoading:
          state?.personalInformation.isLoading ||
          state?.userFunds.isLoading ||
          state?.userProductTypes.isLoading ||
          state?.existingBanks.isLoading ||
          state?.RMDSetting.isLoading ||
          state?.automaticInvestments.systematicPurchasesLoading ||
          state?.automaticInvestments.systematicRedemptionsLoading ||
          state?.automaticInvestments.systematicExchangesLoading ||
          state?.automaticInvestments.autoMaxLoading,
        isLoaded:
          state?.personalInformation.isLoaded &&
          state?.userFunds.isLoaded &&
          state?.userProductTypes.isLoaded &&
          state?.existingBanks.isLoaded &&
          state?.RMDSetting.isLoaded &&
          !state?.automaticInvestments.systematicPurchasesLoading &&
          !state?.automaticInvestments.systematicRedemptionsLoading &&
          !state?.automaticInvestments.systematicExchangesLoading &&
          !state?.automaticInvestments.autoMaxLoading,
        hasFailed:
          state?.personalInformation.hasFailed ||
          state?.userFunds.hasFailed ||
          state?.userProductTypes.hasFailed ||
          state?.existingBanks.hasFailed ||
          state?.RMDSetting.hasFailed ||
          state?.automaticInvestments.systematicPurchasesFailed ||
          state?.automaticInvestments.systematicRedemptionsFailed ||
          state?.automaticInvestments.systematicExchangesFailed ||
          state?.automaticInvestments.autoMaxFailed,
      };
    case EXCHANGE_TRANSACTION:
      return {
        isLoading:
          state?.personalInformation.isLoading ||
          state?.userFunds.isLoading ||
          state?.userProductTypes.isLoading ||
          state?.RMDSetting.isLoading ||
          state?.automaticInvestments.systematicPurchasesLoading ||
          state?.automaticInvestments.systematicRedemptionsLoading ||
          state?.automaticInvestments.systematicExchangesLoading ||
          state?.automaticInvestments.autoMaxLoading ||
          state?.IRALimit.isLoading,
        isLoaded:
          state?.personalInformation.isLoaded &&
          state?.userFunds.isLoaded &&
          state?.userProductTypes.isLoaded &&
          state?.RMDSetting.isLoaded &&
          !state?.automaticInvestments.systematicPurchasesLoading &&
          !state?.automaticInvestments.systematicRedemptionsLoading &&
          !state?.automaticInvestments.systematicExchangesLoading &&
          !state?.automaticInvestments.autoMaxLoading &&
          state?.IRALimit.isLoaded,
        hasFailed:
          state?.personalInformation.hasFailed ||
          state?.userFunds.hasFailed ||
          state?.userProductTypes.hasFailed ||
          state?.RMDSetting.hasFailed ||
          state?.automaticInvestments.systematicPurchasesFailed ||
          state?.automaticInvestments.systematicRedemptionsFailed ||
          state?.automaticInvestments.systematicExchangesFailed ||
          state?.automaticInvestments.autoMaxFailed ||
          state?.IRALimit.hasFailed,
      };
    case LANDING:
      return {
        isLoading:
          state?.personalInformation.isLoading ||
          state?.userFunds.isLoading ||
          state?.userProductTypes.isLoading ||
          state?.RMDSetting.isLoading,
        isLoaded:
          state?.personalInformation.isLoaded &&
          state?.userFunds.isLoaded &&
          state?.userProductTypes.isLoaded &&
          state?.RMDSetting.isLoaded,
        hasFailed:
          state?.personalInformation.hasFailed ||
          state?.userFunds.hasFailed ||
          state?.userProductTypes.hasFailed ||
          state?.RMDSetting.hasFailed,
      };
    case ADD_BANK:
      return {};
    case ROTH_CONVERSION:
      return {
        isLoading:
          state?.personalInformation.isLoading ||
          state?.userFunds.isLoading ||
          state?.userProductTypes.isLoading ||
          state?.RMDSetting.isLoading ||
          state?.beneficiaries.isLoading,
        isLoaded:
          state?.personalInformation.isLoaded &&
          state?.userFunds.isLoaded &&
          state?.userProductTypes.isLoaded &&
          state?.RMDSetting.isLoaded &&
          state?.beneficiaries.isLoaded,
        hasFailed:
          state?.personalInformation.hasFailed ||
          state?.userFunds.hasFailed ||
          state?.userProductTypes.hasFailed ||
          state?.RMDSetting.hasFailed ||
          state?.beneficiaries.hasError,
      };
    case QCD_TRANSACTION:
      return {
        isLoading:
          state?.personalInformation.isLoading ||
          state?.userFunds.isLoading ||
          state?.userFunds.agreementMapIsLoading ||
          state?.userProductTypes.isLoading ||
          state?.existingBanks.isLoading ||
          state?.RMDSetting.isLoading ||
          state?.qcd.isLoading,
        isLoaded:
          state?.personalInformation.isLoaded &&
          state?.userFunds.isLoaded &&
          state?.userFunds.agreementMapIsLoaded &&
          state?.userProductTypes.isLoaded &&
          state?.existingBanks.isLoaded &&
          state?.RMDSetting.isLoaded &&
          state?.qcd.isLoaded,
        hasFailed:
          state?.personalInformation.hasFailed ||
          state?.userFunds.hasFailed ||
          state?.userFunds.agreementMapHasFailed ||
          state?.userProductTypes.hasFailed ||
          state?.existingBanks.hasFailed ||
          state?.RMDSetting.hasFailed ||
          state?.qcd.hasError,
      };
    default:
      return {
        isLoading: false,
        isLoaded: false,
        hasFailed: true,
      };
  }
};

export const getIsLoading = createSelector(
  [getApplicationStatus],
  ({ isLoading }) => isLoading
);
export const getAppLoaded = createSelector(
  [getApplicationStatus],
  ({ isLoaded }) => isLoaded
);
export const getHasFailed = createSelector(
  [getApplicationStatus],
  ({ hasFailed }) => hasFailed
);
